import React from "react";
import Blocks from "blocks";
import MoreNews from "components/more-news";
import "./blog-article.scss";
import MoreBlog from "../more-blog";

const BlogArticle = ({ entry: { title, articleBuilder } }) => {
  return (
    <div className="Page">
      <div className="space-for-nav">
        <header className="BlogArticle-header">
          <h1 className="BlogArticle-header-heading">{title}</h1>
        </header>
        <div className="BlogArticle-body">
          <Blocks blocks={articleBuilder} />
        </div>
        <div className="BlogArticle-more">
          <MoreBlog />
        </div>
      </div>
    </div>
  );
};

export default BlogArticle;
